<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="活动商品：" prop="goodsId">
            <el-select style="width: 420px;" v-model="ruleForm.goodsId" placeholder="请选择商品">
              <el-option v-for="(item,index) in goodsList" :key="index" :label="item.goodsName" :value="item.goodsId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.giveawaySpecPageVoList.length > 0" label="活动规格：" prop="giveawaySpecPageVoList">
            <div v-for="(item,index) in ruleForm.giveawaySpecPageVoList" :key="index"><el-checkbox v-model="item.isChecked">{{item.goodsSpecName}}</el-checkbox></div>
          </el-form-item>
          <el-form-item label="活动时间：" prop="activityTime">
            <el-date-picker
              v-model="activityTime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <div class="mt-warm-txt"><span>设置活动开始结束时间，用户可以在设置时间内获得赠品</span></div>
          </el-form-item>
          <el-form-item label="活动文案：" prop="activityText">
            <el-input style="width: 424px;" v-model="ruleForm.activityText" placeholder="请输入活动文案"></el-input>
          </el-form-item>
          <el-form-item label="满件数量：" prop="fullPieceNumber">
            <el-input style="width: 424px;" v-model="ruleForm.fullPieceNumber" placeholder="请输入满件数量（个），默认1"></el-input>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { number } from 'echarts';
import { saveGiveaway, fetchGiveawayDetailById, updateGiveaway, queryAllEnableGoodsList } from '@/api/giftPromotion'
export default {
  name: 'GiftPromotionAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      dataId: this.$route.query.dataId,
      activityTime:['',''],
      goodsList:[],
      ruleForm: {
        goodsId:'',
        activityTime:['',''],
        activityText: '',
        fullPieceNumber:'',
        status: false,
        goodsSpecIds:[],
        giveawaySpecPageVoList:[]
      },
      rules: {
        goodsId: [
          { required: true, message: '请选择商品', trigger: 'blur' }
        ],
        giveawaySpecPageVoList: [
          { required: true, message: '请选择商品规格', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        activityText: [
          { required: true, message: '请输入活动文案', trigger: 'blur' }
        ]
      },
      isOne:1
    }
  },
  watch: {
    'ruleForm.goodsId': {
      handler(newVal, oldVal) {
        var that = this;
        if(that.dataId == '' || (that.dataId != '' && that.isOne == 2)){
          that.goodsList.forEach(function(item){
            if(newVal == item.goodsId){
              that.ruleForm.giveawaySpecPageVoList = item.giveawaySpecPageVoList;
            }
          });
        }
        that.isOne = 2;
      }
    }
  },
  mounted () {
    if (this.$route.query.dataId === undefined || this.$route.query.dataId === 'undefined' || this.$route.query.dataId === '') {
      this.dataId = ''
    } else {
      let that = this
      fetchGiveawayDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.goodsId = data.goodsId
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.activityTime = [data.startDateTime,data.endDateTime]
          that.activityTime = [data.startDateTime,data.endDateTime]
          that.ruleForm.activityText = data.activityText
          that.ruleForm.fullPieceNumber = data.fullPieceNumber
          that.ruleForm.goodsSpecIds = data.specIdList
          that.goodsListFun();
        }
      })
    }
  },
  created() {
    if(this.dataId == '' || this.dataId == undefined || this.dataId == 'undefined'){
      this.goodsListFun();
    }
  },
  methods: {
    // 查询所有上架的商品列表
    goodsListFun(){
      var that = this;
      queryAllEnableGoodsList({}).then((res) => {
          if (res.errorCode === '0000') {
            var data = res.data;
            var giveawaySpecPageVoList = [];
            if(that.dataId == ''){
              data.forEach(function(item){
                item.giveawaySpecPageVoList.forEach(function(item2){
                  item2.isChecked = false;
                })
              })
            }else{
              data.forEach(function(item){
                if(that.ruleForm.goodsId == item.goodsId){
                  giveawaySpecPageVoList = item.giveawaySpecPageVoList;
                }
                item.giveawaySpecPageVoList.forEach(function(item2){
                  if(that.ruleForm.goodsSpecIds.indexOf(item2.goodsSpecId) > -1){
                    item2.isChecked = true;
                  }else{
                    item2.isChecked = false;
                  }
                })
              })
            }
            that.ruleForm.giveawaySpecPageVoList = giveawaySpecPageVoList;
            that.goodsList = data;
          }
        })
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    bannerImgBtn (file) {
      this.ruleForm.imgUrl = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var imgUrl = '';
      fileList.forEach(function(item){
        imgUrl = item.url;
      });
      this.ruleForm.imgUrl = imgUrl;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let goodsId = that.ruleForm.goodsId
      let goodsSpecIds = []
      let activityTime = that.activityTime
      let activityText = that.ruleForm.activityText
      let fullPieceNumber = that.ruleForm.fullPieceNumber
      let status = that.ruleForm.status ? 1 : 0
      var giveawaySpecPageVoList = that.ruleForm.giveawaySpecPageVoList
      giveawaySpecPageVoList.forEach(function(item){
        if(item.isChecked == true){
          goodsSpecIds.push(item.goodsSpecId)
        }
      });
      if (goodsId === '') {
        this.$message.error('请选择商品')
        return false
      }
      if (goodsSpecIds.length === 0) {
        this.$message.error('请选择商品规格')
        return false
      }
      if (activityTime[0] === '') {
        this.$message.error('请选择活动时间')
        return false
      }
      if (activityText === '') {
        this.$message.error('请输入活动文案')
        return false
      }
      let passData = {
        goodsId: goodsId, startDateTime: activityTime[0], endDateTime: activityTime[1], activityText: activityText, fullPieceNumber: fullPieceNumber, status: status, goodsSpecIds: goodsSpecIds
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateGiveaway(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveGiveaway(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/GiftPromotion/GiftPromotionAdd.vue